import React, { useState } from 'react';

import styles from './styles/text-field.module.css';

import GuideBox from './GuideBox';
import { ReactComponent as EyeClose } from '../../../assets/design-system/eye/eye-close.svg';
import { ReactComponent as EyeOpen } from '../../../assets/design-system/eye/eye-open.svg';

export default function TextField({ width, height, label, maxCount, placeholder, name, value, leadingIcon, trailingIcon, validationStatus, guideMap, isPassword, pattern, handleChange, handleClickTrailingIcon }) {
    const [isVisible, setIsVisible] = useState(false);
    
    const inputType = isPassword ? (isVisible ? 'text' : 'password') : 'text';

    const isInfo = label || maxCount;

    const isTrailingIcon = isPassword || trailingIcon;

    const handleChangeInput = (e) => {
        let processedValue = e.target.value;
        
        if (pattern) {
            processedValue = processedValue.replace(pattern, '');
        }

        handleChange({
            target: {
                name: name,
                value: processedValue
            }
        });
    };

    const getTrailingIcon = () => {
        if (isPassword) {
            return isVisible ? <EyeOpen /> : <EyeClose />;
        }

        return trailingIcon;
    };

    const clickTrailingIcon = () => {
        if (isPassword) {
            setIsVisible(!isVisible);
        }

        handleClickTrailingIcon?.();
    };


    const getValidationMessage = () => {
        switch(validationStatus) {
            case 'valid': return `사용 가능한 ${label}입니다.`;
            case 'invalid': return `사용 불가능한 ${label}입니다.`;
            default: return null;
        }
    };

    return (
        <div className={styles.wrapper} style={{ width }}>
            {isInfo &&
                <div className={styles.boxInfo}>
                    {label && <p className={styles.label}>{label}</p>}
                    {maxCount && <p className={styles.count}>{value?.length}/{maxCount}</p>}
                </div>
            }
            <div className={styles.containerInput} data-type={height} data-color={validationStatus}>
                <div className={styles.boxInput}>
                    {leadingIcon && <div className={styles.icon}>{leadingIcon}</div>}
                    <input
                        type={inputType}
                        placeholder={placeholder}
                        name={name}
                        value={value}
                        onChange={handleChangeInput}
                        autoComplete={isPassword ? 'new-password' : 'off'}
                        readOnly={handleChange === null}
                    />
                </div>
                {isTrailingIcon &&
                    <div
                        className={styles.icon}
                        data-type='trail'
                        onClick={clickTrailingIcon}
                    >
                        {getTrailingIcon()}
                    </div>
                }
            </div>
            {validationStatus &&
                <p
                    className={styles.message}
                    data-color={validationStatus}
                >
                    {getValidationMessage()}
                </p>
            }
            {guideMap && <GuideBox guideMap={guideMap} />}
        </div>
    );
}